<template>
  <div class="layout">
    <Tabs :data="['基础设置', '表单设计', '流程设计']"
    @on-tab="handleTab"
    @on-save="handleSave"
    @on-show-json="showJson"
    :tab="tab" />
    <keep-alive>
      <component
      :is="currentTabComponent"
      :mData="mData"
      @on-mode="handleMode" />
    </keep-alive>
    <el-drawer title="生成JSON"
                 :visible.sync="generateJsonVisible"
                 size="70%"
                 :style="zoomScaleStyle"
                 destroy-on-close
                 :modal-append-to-body="false"
                 >
        <v-json-editor v-model="modelJsonPreview"
                       :height="jsonEditerHeight"></v-json-editor>
      </el-drawer>
  </div>
</template>

<script>
import Tabs from './Tabs'
import { FormDesign } from '../form'
import { Flowable } from '../flowable'
import { BaseSet } from '../baseset'
import apiProc from '../api/proc'
import { getPath } from '@/framework/util/systemTools'
export default {
  components: {
    VJsonEditor: () => import(/* webpackChunkName: 'workFlowFormDesign' */'v-jsoneditor'),
    Tabs,
    FormDesign,
    Flowable,
    BaseSet
  },
  data() {
    return {
      modelJsonPreview: {},
      generateJsonVisible: false,
      tab: 0,
      formModel: null, // 表单设计
      wfSimpleProc: null, // 基础设置
      wfSimpleTaskInfo: null, // 流程设计
      mData: null
    }
  },
  computed: {
    currentTabComponent() {
      switch (this.tab) {
        case 2:
          return 'Flowable'
        case 1:
          return 'FormDesign'
        default:
          return 'BaseSet'
      }
    },
    zoomScaleStyle() {
      if (document.documentElement.style.zoom) {
        let scale = 1 / document.documentElement.style.zoom
        return 'zoom:' + scale + ''
      }
      return ''
    },
    jsonEditerHeight() {
      if (document.documentElement.style.zoom) {
        let scale = 85 / document.documentElement.style.zoom
        return scale + 'vh'
      }
      return '85vh'
    }
  },
  created() {
    const {
      query
    } = this.$route
    if (query && query.id) {
      this.procModelGet({ id: query.id })
    } else {
      this.procModelGet()
    }
  },
  methods: {
    async procModelGet(params) {
      try {
        const { code, data } = await apiProc.apiProcModelGet(params)
        this.mData = data
        if (code === 200) {
          this.mData = data
        }
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async procModelSave(postdata, isTip = false) {
      try {
        const { code, data } = await apiProc.apiProcModelSave(postdata)
        if (code === 200) {
          this.mData = data
          if (isTip) {
            this.$message.success('模型已成功保存！')
          }
        }
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async procModelPublish() {
      try {
        const result = await this.$confirm('确定要发布此流程吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        if (result) {
          const procId = await this.getProcId()
          if (procId) {
            const { code } = await apiProc.apiProcModelPublish(procId)
            if (code === 200) {
              this.$message.success('模型已成功发布！')
              setTimeout(() => {
                this.$router.push({
                  path: '/static/simple/list'
                })
              }, 2000)
            }
          }
        }
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async procModelMode2() {
      try {
        const result = await this.$confirm('注，此过程不可逆，确定要从简易流程模式转换为bpmn2.0复杂流程模型吗？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        if (result) {
          const procId = await this.getProcId()
          if (procId) {
            const { code } = await apiProc.apiProcModelMode2(procId)
            if (code === 200) {
              this.route2ModelPage()
            }
          }
        }
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async getProcId() {
      await this.procModelSave(this.mData)
      const {
        wfSimpleProc
      } = this.mData
      const procId = wfSimpleProc?.id ? wfSimpleProc.id : ''
      return procId
    },
    route2ModelPage() {
      const item = this.$store.getters.menu[4].children[0]
      this.$router.push({
        path: getPath({
          name: item.label,
          src: item.path
        }, item.meta),
        query: item.query
      })
    },
    handleTab(item, i) {
      this.tab = i
    },
    handleSave(type) {
      switch (type) {
        case 'publish':
          this.procModelPublish()
          break
        case 'mode2':
          this.procModelMode2()
          break
        default:
          this.procModelSave(this.mData, true)
      }
    },
    handleMode(type, val) {
      this.mData[type] = val
    },
    showJson() {
      this.modelJsonPreview = this.mData
      this.generateJsonVisible = true
    }
  }
}
</script>

<style scoped>
.layout {
  /* height: 100%;
  overflow-y: auto; */
  min-height: 500px;
}
</style>
